import { experimentsApi } from "./api";
export const experimentsReducers = {
  [experimentsApi.reducerPath]: experimentsApi.reducer,
};
export const experimentsMiddleware = [experimentsApi.middleware];
